import { render, staticRenderFns } from "./ModalVir.vue?vue&type=template&id=92cd47ac"
import script from "./ModalVir.vue?vue&type=script&lang=js"
export * from "./ModalVir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports